import React from 'react'
import { Row, Col } from 'reactstrap'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Paper from '@material-ui/core/Paper'
import { Select } from 'components/select'
import { formatDate } from 'utils/dateUtilities'
import { orderStatus } from 'enums/orderStatus'
import { formatCurrency } from 'utils/numberUtilities'

export const OrderDetails = ({ localize, classes, entity, onStatusChanged }) => {
  let exchangeRate = '-'
  if (entity.currencyName) {
    exchangeRate = `${formatCurrency({ value: 1, code: entity.currencyName })} = ${formatCurrency({ value: entity.exchangeRate })}`
  }
  return (
    <Row>
      <Col>
        <Paper variant='outlined'>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{localize('orders.supplier')}</TableCell>
                <TableCell>{localize('orders.dateOfOrder')}</TableCell>
                <TableCell>{localize('orders.currency')}</TableCell>
                <TableCell>{localize('orders.exchangeRate')}</TableCell>
                <TableCell>{localize('orders.status')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{entity.supplier.name}</TableCell>
                <TableCell>{formatDate(entity.dateOfOrder)}</TableCell>
                <TableCell>{entity.currencyName || '-'}</TableCell>
                <TableCell>{exchangeRate}</TableCell>
                <TableCell>
                  <Select value={entity.status} onChange={onStatusChanged}
                    placeholder={localize('orders.status')} disabled
                    enum={orderStatus} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      </Col>
    </Row>
  )
}